import {
  ContextMenuPayload,
  SET_CONTEXT_MENU_VISIBILITY,
  SET_MULTIPLE_SELECTION,
} from "./types";

const initialState: any = {
  visibility: false,
  coordinates: {
    top: 0,
    left: 0,
  },
  isMultipleSelect: false,
};

export function contextMenuReducerv2(
  state = initialState,
  action: ContextMenuPayload
) {
  switch (action.type) {
    case SET_CONTEXT_MENU_VISIBILITY:
      return {
        ...state,
        ...action.data,
      };
    case SET_MULTIPLE_SELECTION:
      return {
        ...state,
        isMultipleSelect: action.data,
      }
    default:
      return state
  }
}
